<!--
 * @Author: 张天昊
 * @Date: 2024-10-21 17:21:42
 * @LastEditTime: 2024-11-05 11:28:51
 * @LastEditors: 张天昊
 * @Description: 
 * @FilePath: /Mobile/src/pages/itineraryUniversal/components/NormalTag.vue
-->
<script>
import { defineComponent, ref, computed } from 'vue';

export default defineComponent({
  props: {
    type: {
      type: String,
      required: true
    },
    name: {
      type: String,
      required: true
    },
    tags: {
      type: Array,
      default: () => []
    }
  },
  setup(props) {
    const popupShow = ref(false);
    // ['1', '常规团'],
    // ['2', '一日游'],
    // ['3', '单项委托'],
    // ['4', '单项一日游委托']
    const showExtra = computed(() => ['3', '4'].includes(props.type))

    function onClick() {
      if (showExtra.value) {
        popupShow.value = true;
      }
    }

    function onClose() {
      popupShow.value = false;
    }
    return {
      popupShow,
      showExtra,
      onClick,
      onClose
    };
  }
});
</script>

<template>
  <span v-if="name">
    <!-- TODO svg + 点9图 -->
    <van-tag
      v-if="name"
      class="primary-tag"
      color="rgba(255,255,255,0.2)"
      @click="onClick"
    >
      {{ name
      }}<svg-icon
        v-if="showExtra"
        pre-path="itineraryUniversal"
        name="ic-arrow"
        class="text-white stroke-white w-12 h-12"
      />
    </van-tag>
    <van-popup class="custom-dialog" v-model="popupShow">
      <template v-if="showExtra">
        <header
          class="py-12 text-center text-20 leading-28 font-semibold van-hairline--bottom"
        >
          委托项目
        </header>
        <div class="py-24 px-37 -mt-10 flex flex-wrap justify-between">
          <van-tag
            v-for="tag in tags"
            :key="tag"
            class="custom-tag mt-10"
            plain
            >{{ tag }}</van-tag
          >
          <!-- 一排4个，不够就填充 -->
          <i v-for="n in 4 - (tags.length % 4)" :key="n" class="w-46"></i>
        </div>
        <footer class="van-hairline--top">
          <van-button class="custom-button" block @click="onClose"
            >关闭</van-button
          >
        </footer>
      </template>
    </van-popup>
  </span>
</template>

<style scoped>
.primary-tag {
  font-size: 14px;
  line-height: 24px;
  font-weight: 500;
  border-radius: 4px;
  padding-left: 5px;
  padding-right: 5px;
}
.custom-tag.van-tag {
  font-size: 16px;
  line-height: 28px;
  color: rgb(var(--color-black-a));
  border-color: #c8c9cc;
  padding: 0 7px;
}
.custom-dialog.van-popup {
  width: 295px;
  border-radius: 4px;
}
.custom-button.van-button.van-button--default {
  color: #229f60;
  border: none;
  font-size: 16px;
  height: 50px;
  font-weight: 600;
}
</style>
